import { render } from "./AppFakeCheckBox.vue?vue&type=template&id=7d2c8873&scoped=true"
import script from "./AppFakeCheckBox.vue?vue&type=script&lang=js"
export * from "./AppFakeCheckBox.vue?vue&type=script&lang=js"

import "./AppFakeCheckBox.vue?vue&type=style&index=0&id=7d2c8873&scoped=true&lang=scss"

import exportComponent from "/var/www/web-love.elena-dating.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2c8873"]])

export default __exports__